import { FaGhost } from "react-icons/fa";

const PageNotFound = () => {
    return (
        <>
        <div className="min-vh-100 d-flex align-items-center justify-content-center error-page">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8 text-center">
                <div className="position-relative mb-4">
                    <FaGhost size={80} />
                    <h1 className="display-1 fw-bold text-purple animate-pulse">404</h1>
                </div>
                
                <div className="mb-4">
                  <p className="fs-4">
                     Página no encontrada.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        </>
    );
  }

export default PageNotFound
